import React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate } from "react-router-dom";
import {
  smdProducts,
  radioLogicProducts,
  antennaProducts,
} from "../data/products";
import { autecProducts } from "../data/autecData";
import { useHeaderScroll } from "./useHeaderScroll";
import DesktopNav from "./DesktopNav";
import MobileDrawer from "./MobileDrawer";
import { useTranslation } from "../utils/i18n";

const logoStyle = {
  width: 160,
  height: 80,
  cursor: "pointer",
  display: "block",
  objectFit: "contain",
  objectPosition: "center center",
};

export default function Header() {
  const navigate = useNavigate();
  const scrolled = useHeaderScroll();
  const { t } = useTranslation();

  const PRODUCTS = [
    {
      id: "smd",
      title: "SMD",
      image: "/images/products/SMD/si-industrisandare/1.png",
      items: smdProducts,
    },
    {
      id: "radiologic",
      title: "RADIOLOGIC",
      image: "/images/products/RADIOLOGIC.png",
      items: radioLogicProducts,
    },
    {
      id: "antenner",
      title: t("productsPage.groups.antenner.title"),
      image: "/images/products/Antenner/AK40.png",
      items: antennaProducts,
    },
    {
      id: "autec",
      title: "AUTEC",
      image: "/images/partners/autec_product.jpeg",
      items: autecProducts,
    },
  ];
  const [drawerOpen, setDrawerOpen] = React.useState(false);

  const handleCategorySelect = React.useCallback(
    (path = "/products") => {
      setDrawerOpen(false);
      navigate(path);
    },
    [navigate],
  );

  const handleProductSelect = React.useCallback(
    (slug) => {
      setDrawerOpen(false);
      const isAutecProduct = autecProducts.some((p) => p.slug === slug);
      const base = isAutecProduct ? "/autecproducts" : "/products";
      navigate(`${base}/${slug}`);
    },
    [navigate],
  );

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        background: scrolled ? "#FFFFFF" : "transparent",
        boxShadow: scrolled ? "0 6px 24px rgba(0,0,0,0.08)" : "none",
        transition: "background-color 240ms ease, box-shadow 240ms ease",
        backdropFilter: scrolled ? "saturate(180%) blur(6px)" : "none",
        justifyContent: "center",
        height: { xs: 70, md: 80 },
      }}
    >
      <Toolbar sx={{ width: "100%", px: 0 }}>
        <Box
          sx={{
            width: "100%",
            maxWidth: "var(--content-max-width)",
            mx: "auto",
            px: "var(--site-gutter)",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              width: 180,
              height: 60,
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
              flexShrink: 0,
            }}
          >
            <img
              src={
                scrolled
                  ? "/images/logo/SMD_logo_black.svg"
                  : "/images/logo/SMD_logo_inverted.svg"
              }
              alt="Radio SMD Logo"
              style={logoStyle}
              onClick={() => navigate("/")}
            />
          </Box>

          <IconButton
            edge="start"
            aria-label="menu"
            onClick={() => setDrawerOpen(true)}
            sx={{
              display: { xs: "flex", md: "none" },
              color: scrolled ? "#0B0F13" : "#fff",
            }}
          >
            <MenuIcon />
          </IconButton>

          <DesktopNav
            scrolled={scrolled}
            products={PRODUCTS}
            onCategorySelect={handleCategorySelect}
            onProductSelect={handleProductSelect}
          />
        </Box>

        <MobileDrawer
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          products={PRODUCTS}
          onCategorySelect={handleCategorySelect}
          onProductSelect={handleProductSelect}
        />
      </Toolbar>
    </AppBar>
  );
}
